module.exports = __webpack_public_path__ + "img/i-turkey.d37f11bc.svg";